import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALS_CREATE,
    ACTION_TRIALS_LOAD,
    ACTION_TRIALS_LOAD_BY_ID,

    ACTION_TRIALS_SAVE,
    ACTION_TRIALS_VALIDATE,
    CreateFailure,
    CreateSuccess,
    ITrialCreateAction,
    ITrialCreateFailureAction,
    ITrialCreateSuccessAction,
    ITrialLoadAction,
    ITrialLoadByIdAction,
    ITrialLoadFailureAction,
    ITrialLoadSuccessAction,

    ITrialSaveAction,
    ITrialSaveFailureAction,
    ITrialSaveSuccessAction,
    ITrialValidateAction,
    ITrialValidateFailureAction,
    ITrialValidateSuccessAction,
    LoadFailure,
    LoadSuccess,
    SaveFailure,
    SaveSuccess,
    ValidateFailure,
    ValidateSuccess,
} from "../actions/trial";
import { trialsApi } from "../services/trials";

export const
    getTrialsEpic = (action$): Observable<ITrialLoadSuccessAction | ITrialLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALS_LOAD)
            .mergeMap((_action: ITrialLoadAction) => {
                return trialsApi
                    .getTrials()
                    .map(response =>
                        LoadSuccess(response.trials, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialsByIdEpic = (action$): Observable<ITrialLoadSuccessAction | ITrialLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALS_LOAD_BY_ID)
            .mergeMap((action: ITrialLoadByIdAction) => {
                return trialsApi
                    .getTrialById(action.id)
                    .map(response =>
                        LoadSuccess(response.trial, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialEpic = (action$): Observable<ITrialSaveSuccessAction | ITrialSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALS_SAVE)
            .mergeMap((action: ITrialSaveAction) => {
                return trialsApi
                    .setTrial(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trial, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialEpic = (action$): Observable<ITrialCreateSuccessAction | ITrialCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALS_CREATE)
            .mergeMap((_action: ITrialCreateAction) => {
                return trialsApi
                    .createTrial()
                    .map(response =>
                        CreateSuccess(response.trial, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialEpic = (action$): Observable<ITrialValidateSuccessAction | ITrialValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALS_VALIDATE)
            .mergeMap((action: ITrialValidateAction) => {
                return trialsApi
                    .validateTrial(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trial, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }